'use client'
import { useMyInfosLoader } from '@/shared/api/myInfos'
import { NoSSR } from '@/shared/ui/NoSSR'
import { Expertises } from './Expertises'

export function ExpertisesPage() {
  return (
    <NoSSR>
      <ExpertisesList />
    </NoSSR>
  )
}

function ExpertisesList() {
  const myInfos = useMyInfosLoader()

  return (
    <div className="flex-1 overflow-auto">
      <Expertises expertises={myInfos.expertises} />
    </div>
  )
}
